export const common = {
  // Header
  'header.home': 'Inicio',
  'header.about': 'Acerca de',
  'header.faq': 'Preguntas',
  'header.contact': 'Contacto',
  'header.signIn': 'Iniciar sesión',
  'header.getStarted': 'Comenzar',

  // Footer
  'footer.tagline': 'Eleva tu futuro financiero',
  'footer.description': 'Soluciones de pago seguras, confiables e innovadoras para individuos y empresas en todo el mundo.',
  'footer.quickLinks': 'Enlaces rápidos',
  'footer.services': 'Servicios',
  'footer.contact': 'Contáctenos',
  'footer.address': '789 Summit Avenue, San Francisco, CA 94102',
  'footer.email': 'support@pinnaclepayments.com',
  'footer.phone': '+1 (415) 555-1234',
  'footer.copyright': '© 2024 Pinnacle Payments. Todos los derechos reservados.',
  'footer.privacy': 'Política de privacidad',
  'footer.terms': 'Términos de servicio',

  // Home Page
  'home.hero.title': 'Eleva tu futuro financiero',
  'home.hero.subtitle': 'Experimenta una banca sin problemas con tecnología de vanguardia. Administra tu riqueza, invierte inteligentemente y alcanza tus objetivos financieros con Pinnacle Payments.',
  'home.hero.cta': 'Comenzar hoy',
  'home.hero.learn': 'Saber más',

  'home.stats.users': 'Usuarios activos',
  'home.stats.countries': 'Países atendidos',
  'home.stats.transactions': 'Transacciones procesadas',
  'home.stats.support': 'Soporte 24/7',

  'home.services.title': 'Nuestros servicios premium',
  'home.services.subtitle': 'Soluciones financieras integrales adaptadas a tus necesidades',

  'home.services.banking.title': 'Banca digital',
  'home.services.banking.desc': 'Banca moderna al alcance de tu mano con transferencias instantáneas, pagos de facturas y seguimiento de saldo en tiempo real.',

  'home.services.investment.title': 'Soluciones de inversión',
  'home.services.investment.desc': 'Haz crecer tu riqueza con nuestras carteras de inversión seleccionadas y orientación financiera experta.',

  'home.services.loans.title': 'Préstamos flexibles',
  'home.services.loans.desc': 'Préstamos personales y comerciales de aprobación rápida con tasas competitivas y términos de pago flexibles.',

  'home.services.cards.title': 'Tarjetas virtuales',
  'home.services.cards.desc': 'Tarjetas de débito y crédito virtuales seguras para compras en línea y transacciones internacionales seguras.',

  'home.features.title': 'Por qué elegir Pinnacle Payments',
  'home.features.subtitle': 'Experimenta la excelencia bancaria con características líderes en la industria',

  'home.features.security.title': 'Seguridad bancaria',
  'home.features.security.desc': 'Tus fondos están protegidos con encriptación de grado militar y autenticación multifactor.',

  'home.features.instant.title': 'Transferencias instantáneas',
  'home.features.instant.desc': 'Envía y recibe dinero instantáneamente en más de 180 países sin demoras.',

  'home.features.support.title': 'Soporte experto 24/7',
  'home.features.support.desc': 'Nuestro equipo dedicado siempre está disponible para ayudarte con cualquier pregunta o inquietud.',

  'home.features.rates.title': 'Tasas competitivas',
  'home.features.rates.desc': 'Disfruta de las mejores tasas de cambio y las tarifas más bajas de la industria para todas las transacciones.',

  'home.plans.title': 'Planes de crecimiento financiero',
  'home.plans.subtitle': 'Elige el plan perfecto para alcanzar tus objetivos financieros',

  'home.plans.dps.title': 'Esquema de pensión de depósito',
  'home.plans.dps.rate': 'Rendimiento anual',
  'home.plans.dps.term': 'Términos flexibles',
  'home.plans.dps.feature1': 'Opciones de depósito mensual',
  'home.plans.dps.feature2': 'Rendimientos garantizados',
  'home.plans.dps.feature3': 'Beneficios fiscales',
  'home.plans.dps.feature4': 'Opción de retiro anticipado',
  'home.plans.dps.cta': 'Comenzar a ahorrar',

  'home.plans.fdr.title': 'Recibo de depósito fijo',
  'home.plans.fdr.rate': 'Tasa de interés',
  'home.plans.fdr.term': 'Período de bloqueo',
  'home.plans.fdr.feature1': 'Rendimientos altos garantizados',
  'home.plans.fdr.feature2': 'Opciones de plazo flexibles',
  'home.plans.fdr.feature3': 'Préstamo contra FDR',
  'home.plans.fdr.feature4': 'Renovación automática disponible',
  'home.plans.fdr.cta': 'Invertir ahora',

  'home.plans.loan.title': 'Préstamos personales',
  'home.plans.loan.rate': 'Desde',
  'home.plans.loan.term': 'Período de pago',
  'home.plans.loan.feature1': 'Aprobación rápida en 24 horas',
  'home.plans.loan.feature2': 'Sin cargos ocultos',
  'home.plans.loan.feature3': 'Opciones EMI flexibles',
  'home.plans.loan.feature4': 'Documentación mínima',
  'home.plans.loan.cta': 'Aplicar ahora',

  'home.testimonials.title': 'Lo que dicen nuestros clientes',
  'home.testimonials.subtitle': 'Únete a miles de clientes satisfechos en todo el mundo',

  'home.cta.title': '¿Listo para transformar tu futuro financiero?',
  'home.cta.subtitle': 'Únete a millones de usuarios que confían en Pinnacle Payments para sus necesidades financieras',
  'home.cta.button': 'Crea tu cuenta',

  // About Page
  'about.hero.title': 'Acerca de Pinnacle Payments',
  'about.hero.subtitle': 'Liderando el futuro de las finanzas digitales desde 2010',

  'about.story.title': 'Nuestra historia',
  'about.story.content': 'Fundada en 2010, Pinnacle Payments surgió de una visión para revolucionar la industria de servicios financieros. Reconocimos que la banca tradicional no estaba satisfaciendo las necesidades de un mundo digital en rápida evolución. Nuestros fundadores, un equipo de pioneros fintech y veteranos bancarios, se propusieron crear una plataforma que combine tecnología de vanguardia con servicio personalizado. Hoy, servimos a más de 8 millones de clientes en 180 países, procesando miles de millones en transacciones anualmente mientras mantenemos nuestro compromiso con la seguridad, innovación y satisfacción del cliente.',

  'about.mission.title': 'Nuestra misión',
  'about.mission.content': 'Empoderar a individuos y empresas en todo el mundo con soluciones financieras accesibles, seguras e innovadoras que les permitan alcanzar sus objetivos y construir prosperidad duradera.',

  'about.vision.title': 'Nuestra visión',
  'about.vision.content': 'Convertirnos en la plataforma financiera digital más confiable del mundo, estableciendo nuevos estándares de excelencia, seguridad y experiencia del cliente en la industria fintech.',

  'about.stats.customers': 'Clientes felices',
  'about.stats.transactions': 'Transacciones procesadas',
  'about.stats.countries': 'Países en todo el mundo',
  'about.stats.rating': 'Calificación del cliente',

  'about.values.title': 'Nuestros valores fundamentales',
  'about.values.security.title': 'Seguridad primero',
  'about.values.security.desc': 'Priorizamos la seguridad de tus fondos y datos por encima de todo.',
  'about.values.innovation.title': 'Innovación',
  'about.values.innovation.desc': 'Evolucionando continuamente para proporcionar soluciones financieras de vanguardia.',
  'about.values.transparency.title': 'Transparencia',
  'about.values.transparency.desc': 'Comunicación clara y prácticas honestas en todo lo que hacemos.',
  'about.values.excellence.title': 'Excelencia',
  'about.values.excellence.desc': 'Entregando servicio y resultados excepcionales para nuestros clientes.',

  'about.team.title': 'Conoce a nuestro equipo de liderazgo',
  'about.team.subtitle': 'Profesionales experimentados impulsando la innovación en fintech',

  // FAQ Page
  'faq.title': 'Preguntas frecuentes',
  'faq.subtitle': 'Encuentra respuestas a preguntas comunes sobre nuestros servicios',

  'faq.general': 'General',
  'faq.account': 'Cuenta',
  'faq.security': 'Seguridad',
  'faq.payments': 'Pagos',

  // Contact Page
  'contact.title': 'Ponte en contacto',
  'contact.subtitle': 'Estamos aquí para ayudarte con cualquier pregunta o inquietud',

  'contact.info.title': 'Información de contacto',
  'contact.info.address': 'Visítanos',
  'contact.info.email': 'Envíanos un correo',
  'contact.info.phone': 'Llámanos',
  'contact.info.hours': 'Horario comercial',
  'contact.info.hoursValue': 'Lunes - Viernes: 8:00 AM - 7:00 PM PST',

  'contact.form.title': 'Envíanos un mensaje',
  'contact.form.name': 'Nombre completo',
  'contact.form.email': 'Correo electrónico',
  'contact.form.subject': 'Asunto',
  'contact.form.message': 'Mensaje',
  'contact.form.send': 'Enviar mensaje',

  'contact.map.title': 'Nuestra ubicación',
};

export default common;